module.exports = __webpack_public_path__ + "images/emoji/muscle.9573316646489c3be8c2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/muscle.png
// module id = jcAA
// module chunks = 14